import useTimeFunction from "./useTimeFunction";

function useTimeout(callback, delay) {
  useTimeFunction(callback, delay, setTimeout, clearTimeout);
}

export { useTimeout as default };
